module.exports = __webpack_public_path__ + "666f4187cff0926ba834e9e4c3f2a33d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Lato-Light.woff
// module id = 1481
// module chunks = 0